var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLista({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_568",
    "data-name": "Grupo 568",
    transform: "translate(-584 -804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_965",
    "data-name": "Trazado 965",
    d: "M9.229,18.6V17.2H20.32v1.4Zm0-5.907v-1.4H20.32v1.4Zm0-5.892V5.4H20.32V6.8ZM5.264,19.482a1.583,1.583,0,1,1,1.121-2.7,1.583,1.583,0,0,1-1.121,2.7Zm0-5.911a1.583,1.583,0,0,1,.005-3.165,1.517,1.517,0,0,1,1.115.467,1.533,1.533,0,0,1,.465,1.12,1.512,1.512,0,0,1-.467,1.115A1.533,1.533,0,0,1,5.264,13.571Zm0-5.887A1.591,1.591,0,0,1,3.684,6.1a1.591,1.591,0,0,1,1.585-1.58A1.591,1.591,0,0,1,6.849,6.1a1.591,1.591,0,0,1-1.585,1.58Z",
    transform: "translate(584.316 804.481)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_349",
    "data-name": "Rect\\xE1ngulo 349",
    width: 24,
    height: 24,
    transform: "translate(584 804)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLista);
export default __webpack_public_path__ + "static/media/lista.8a506c7e21686a0ea384175b2d654803.svg";
export { ForwardRef as ReactComponent };